// // // import React from 'react';
// // // import { integrations } from '../mockData';

// // // const Integrations = () => {
// // //   return (
// // //     <section className="py-20 px-6 bg-white">
// // //       <div className="max-w-7xl mx-auto">
// // //         <div className="text-center mb-16">
// // //           <p className="text-pink-500 text-sm font-medium mb-4">{integrations.badge}</p>
// // //           <h2 className="text-4xl md:text-5xl font-bold mb-6">{integrations.title}</h2>
// // //           <p className="text-lg text-gray-600 max-w-3xl mx-auto">{integrations.subtitle}</p>
// // //         </div>

// // //         <div className="flex flex-col md:flex-row items-center gap-12 mb-12">
// // //           <div className="flex-1">
// // //             <img src={integrations.images[0]} alt="Integration 1" className="w-full max-w-sm mx-auto" />
// // //           </div>
// // //           <div className="flex-1">
// // //             <img src={integrations.images[1]} alt="Integration 2" className="w-full max-w-sm mx-auto rounded-2xl shadow-2xl" />
// // //           </div>
// // //         </div>

// // //         <div className="text-center max-w-3xl mx-auto">
// // //           <h3 className="text-3xl font-bold mb-4">{integrations.bottomTitle}</h3>
// // //           <p className="text-lg text-gray-600">{integrations.description}</p>
// // //         </div>
// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // export default Integrations;

// // //INI FIXX 
// // import React from 'react';
// // import { integrations } from '../mockData';

// // const Integrations = () => {
// //   return (
// //     <section id="integrations" className="py-20 px-6 bg-gradient-blue-strong bg-tech-dots">
// //       <div className="max-w-7xl mx-auto">
// //         <div className="text-center mb-16">
// //           <p className="text-brand-green-600 text-sm font-medium mb-4">{integrations.badge}</p>
// //           <h2 className="text-4xl md:text-5xl font-bold mb-6">{integrations.title}</h2>
// //           <p className="text-lg text-gray-600 max-w-3xl mx-auto">{integrations.subtitle}</p>
// //         </div>

// //         <div className="flex flex-col md:flex-row items-center gap-12 mb-12">
// //           <div className="flex-1">
// //             <div className="relative w-full max-w-sm mx-auto">
// //               {/* Screenshot di belakang */}
// //               <div className="absolute top-[6%] left-[11%] w-[78%] h-[84%] overflow-hidden rounded-[2.5rem] z-0">
// //                 <img src={integrations.images[1]} alt="Integration Screenshot" className="w-full h-full object-cover object-top" />
// //               </div>
// //               {/* Phone mockup di depan */}
// //               <img src={integrations.images[0]} alt="Phone Mockup" className="w-full drop-shadow-2xl relative z-10" />
// //             </div>
// //           </div>
// //         </div>

// //         <div className="text-center max-w-3xl mx-auto">
// //           <h3 className="text-3xl font-bold mb-4">{integrations.bottomTitle}</h3>
// //           <p className="text-lg text-gray-600">{integrations.description}</p>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default Integrations;

// import React from 'react';
// import { integrations } from '@/mockData';

// const Integrations = () => {
//   return (
//     // DIUBAH: Dihapus 'bg-gradient-blue-strong bg-tech-dots'
//     <section id="integrations" className="py-20 px-6">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center mb-16">
//           {/* Badge ini sudah OK */}
//           <p className="text-brand-green-500 text-sm font-medium mb-4">{integrations.badge}</p>
//           {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
//           <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">{integrations.title}</h2>
//           {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
//           <p className="text-lg text-gray-300 max-w-3xl mx-auto">{integrations.subtitle}</p>
//         </div>

//         <div className="flex flex-col md:flex-row items-center gap-12 mb-12">
//           <div className="flex-1">
//             <div className="relative w-full max-w-sm mx-auto">
//               {/* Screenshot di belakang */}
//               <div className="absolute top-[6%] left-[11%] w-[78%] h-[84%] overflow-hidden rounded-[2.5rem] z-0">
//                 <img src={integrations.images[1]} alt="Integration Screenshot" className="w-full h-full object-cover object-top" />
//               </div>
//               {/* Phone mockup di depan */}
//               <img src={integrations.images[0]} alt="Phone Mockup" className="w-full drop-shadow-2xl relative z-10" />
//             </div>
//           </div>
//         </div>

//         <div className="text-center max-w-3xl mx-auto">
//           {/* DIUBAH: Teks judul bawah diubah menjadi 'text-white' */}
//           <h3 className="text-3xl font-bold mb-4 text-white">{integrations.bottomTitle}</h3>
//           {/* DIUBAH: Teks deskripsi diubah menjadi 'text-gray-300' */}
//           <p className="text-lg text-gray-300">{integrations.description}</p>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Integrations;

import React from 'react';
import { integrations } from '@/mockData';
import Masonry from './Masonry'; // DIITAMBAHKAN
import './Masonry.css'; // DIITAMBAHKAN

const Integrations = () => {
  // DIITAMBAHKAN: Daftar gambar "banyak" seperti yang Anda minta
  const masonryItems = [
    {
      id: "1",
      img: "https://kontentutorialmpstore-cdn.maduraprime.com/dcfd4bb3-8782-4dcb-8328-c207f95ca3f2.jpg", //
      url: "#",
      height: 1000,
    },
    {
      id: "2",
      img: "https://kontentutorialmpstore-cdn.maduraprime.com/0cea6535-e836-4a9d-a54d-aeba764f8464.jpg", //
      url: "#",
      height: 550,
    },
    {
      id: "3",
      img: "https://kontentutorialmpstore-cdn.maduraprime.com/d5f249db-1fc8-40e8-81b9-8775612c5bd1.jpg", //
      url: "#",
      height: 400,
    },
    {
      id: "4",
      img: "https://kontentutorialmpstore-cdn.maduraprime.com/0fc5fffb-91d0-4445-a578-af0191e976e7.jpg", //
      url: "#",
      height: 950,
    },
    {
      id: "5",
      img: "https://kontentutorialmpstore-cdn.maduraprime.com/780849a3-eed6-4d67-9226-800212b2e7fe.jpg", //
      url: "#",
      height: 480,
    },
    {
      id: "6",
      img: "https://kontentutorialmpstore-cdn.maduraprime.com/e963c7ef-fcbc-4a24-a262-4f67892bca2f.jpg", //
      url: "#",
      height: 620,
    },
    {
      id: "7",
      img: "https://kontentutorialmpstore-cdn.maduraprime.com/637f84f0-cbd7-4226-8f35-7c795fd0d488.jpg", //
      url: "#",
      height: 680,
    },
    {
      id: "8",
      img: "https://kontentutorialmpstore-cdn.maduraprime.com/9257d7d4-b98e-4176-b0a7-4f7efb862913.jpg",
      url: "#",
      height: 400,
    },
  ];


  return (
    <section id="integrations" className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-brand-green-500 text-sm font-medium mb-4">{integrations.badge}</p> {/* */}
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">{integrations.title}</h2> {/* */}
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">{integrations.subtitle}</p> {/* */}
        </div>

        {/* DIUBAH: Blok gambar ponsel statis diganti dengan Masonry */}
        <div className="mb-12">
          <Masonry
            items={masonryItems}
            ease="power3.out"
            duration={0.6}
            stagger={0.05}
            animateFrom="random"
            scaleOnHover={true}
            hoverScale={0.95}
            blurToFocus={true}
            colorShiftOnHover={false}
          />
        </div>

        <div className="text-center max-w-3xl mx-auto">
          <h3 className="text-3xl font-bold mb-4 text-white">{integrations.bottomTitle}</h3> {/* */}
          <p className="text-lg text-gray-300">{integrations.description}</p> {/* */}
        </div>
      </div>
    </section>
  );
};

export default Integrations;